import { render, staticRenderFns } from "./TermsAndConditionsUploadComponent.vue?vue&type=template&id=6b29106e"
import script from "./TermsAndConditionsUploadComponent.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsUploadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports